import React from "react";
import Button from "Components/button/Button";
import PropTypes from "prop-types";
import OrderStepTitle from "Components/orderStepTitle/OrderStepTitle";
import RadioButton from "Components/radiobutton/RadioButton";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import { Icon, attention } from "Icons/index";
import Modal from "Components/smallModal/smallModal";
import HelpTooltip from "Components/helpTooltip/HelpTooltip";

import SupportContactBox from "Components/supportContactBox/SupportContactBox";
import cx from "classnames";
// import s from "./orderForm.scss";

const ContextTypes = {
  router: PropTypes.object,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

export default class CustomerTypeStep extends React.Component {
  state = {
    isWarnModalOpened: false,
  };

  openWarnModal = () => {
    this.setState({ isWarnModalOpened: true });
  };

  closeWarnModal = () => {
    this.setState({ isWarnModalOpened: false });
  };

  goBack = () => {
    this.props.goToStep(1);
  };

  goToNextStep = () => {
    this.props.goToStep(3);
  };

  setCustomerType = (val) => {
    if (val.customer_type === "reseller") {
      this.openWarnModal();
      this.props.setFormFieldValue({ billing_cycle: "monthly" });
    }
    this.props.setFormFieldValue(val);
  };

  render() {
    const {
      formData: { customer_type, country },
    } = this.props;

    const { isMediaMobile, isMediaSM, isMediaMD } = this.context;

    return (
      <div className="orderPage">
        {this.props.stepper}

        {!isMediaMobile() && !isMediaSM() && !isMediaMD() && <SupportContactBox className="supportBox" />}

        <div className={cx("sectionTitle", "titleFP")}>{t("order.add.title.step2")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("order.add.desc.step2")}</div>
          </div>

          <div className="wrapFormsFP">
            <div className="formsFP">
              <RadioButton
                className="inputFull2"
                grouplabel={t("input.label.select.usert.type")}
                children={[
                  {
                    disabled: country !== "IT",
                    value: "private",
                    label: t("radiobtn.label.customer.private"),
                    description: t("radiobtn.desc.customer.private"),
                  },
                  {
                    disabled: false,
                    value: "company",
                    label: t("radiobtn.label.customer.company"),
                    description: t("radiobtn.desc.customer.company"),
                  },
                  {
                    disabled: false,
                    value: "reseller",
                    label: t("radiobtn.label.customer.reseller"),
                    description: t("radiobtn.desc.customer.reseller"),
                  },
                ]}
                name="customer_type"
                value={customer_type}
                onChange={this.setCustomerType}
              />
            </div>
            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" onClick={this.goToNextStep}>
                button.continue
              </Button>
            </div>
          </div>
        </div>

        <Modal title={t("modal.reseller.title")} closeModal={this.closeWarnModal} opened={this.state.isWarnModalOpened}>
          <div>
            <TranslatedString>modal.reseller.desc</TranslatedString>
          </div>

          <div>
            <Button onClick={this.closeWarnModal} type="button">
              button.understood
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

CustomerTypeStep.contextTypes = ContextTypes;
